import {Injectable} from '@angular/core';
import {SessionService} from '../session.service';
import {HttpClient} from '@angular/common/http';
import {BaseHttpService} from '../base.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class JobOrderService extends BaseHttpService {

  private static jobOrderPath = 'api/ecv/joborders/';
  private static jobOrderSkillsPath = (jobOrderNumber: string) => JobOrderService.jobOrderPath + `${jobOrderNumber}/skills`;
  private static jobOrderCitiesPath = (jobOrderNumber: string) => JobOrderService.jobOrderPath + `${jobOrderNumber}/cities`;
  private static jobOrderRequiredSkillsDescriptionPath = (jobOrderNumber: string) => JobOrderService.jobOrderPath + `${jobOrderNumber}/description`;

  constructor(sessionService: SessionService, httpClient: HttpClient) {
    super(httpClient, sessionService);
  }

  public getJobOrderSkills(jobOrderNumber: string): Observable<any> {
    return this.httpGet(JobOrderService.jobOrderSkillsPath(jobOrderNumber));
  }

  public getJobOrderCities(jobOrderNumber: string): Observable<any> {
    return this.httpGet(JobOrderService.jobOrderCitiesPath(jobOrderNumber));
  }

  public getJobOrderRequiredSkillsDescription(jobOrderNumber: string): Observable<any> {
    return this.httpGet(JobOrderService.jobOrderRequiredSkillsDescriptionPath(jobOrderNumber));
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/services/job-order.service.ts